"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[5466],{

/***/ 62790:
/***/ (() => {

// extracted by mini-css-extract-plugin


/***/ }),

/***/ 56288:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ Column)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Column = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", (props)=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: props.$align,
        gap: props.$gap
    }));


/***/ }),

/***/ 51784:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: () => (/* binding */ Text)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Text = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", ({ $theme })=>({
        ...$theme.typography.body,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 93610:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: () => (/* binding */ Link)
/* harmony export */ });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);
/* harmony import */ var _icons_ExternalLinkIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56931);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92146);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67710);




const base = typeof window !== "undefined" ? new URL(`${window.location.protocol}//${window.location.host}`) : new URL("https://app.gadget.dev");
function isInternal(url) {
    try {
        return new URL(url, base).hostname === base.hostname;
    } catch (error) {
        return true;
    }
}
const Link = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const internal = isInternal(props.href);
    const overrides = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        BaseButton: {
            style: {
                paddingLeft: "0px",
                paddingRight: "0px",
                fontSize: "inherit",
                fontWeight: "inherit",
                whiteSpace: "no-wrap"
            }
        },
        EndEnhancer: {
            style: {
                marginLeft: "4px"
            }
        }
    }, props.overrides);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
        ref: ref,
        kind: _Button__WEBPACK_IMPORTED_MODULE_3__/* .KIND */ .TO.minimal,
        $as: "a",
        target: internal ? undefined : "_blank",
        endEnhancer: props.endEnhancer ?? internal ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_icons_ExternalLinkIcon__WEBPACK_IMPORTED_MODULE_4__/* .ExternalLinkIcon */ .h, {
            $size: props.size == _Button__WEBPACK_IMPORTED_MODULE_3__/* .SIZE */ .NO.compact ? 12 : 16
        }),
        ...props,
        overrides: overrides
    });
});


/***/ }),

/***/ 4441:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ PlainButton)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2780);


/**
 * A plain button component that doesn't apply any styling to the contents
 *
 * Useful for making clickable elements inside other things. Try to use this instead of a `div` or `Row` with an `onClick` :)
 */ const PlainButton = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("button", ({ $theme, $row, $selected, $style })=>{
    return {
        fontFamily: "inherit",
        lineHeight: "inherit",
        fontWeight: "inherit",
        fontSize: "inherit",
        textDecoration: "underline",
        display: $row ? "flex" : "initial",
        alignItems: "center",
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .expandPadding */ .ft)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .expandMargin */ .ds)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .expandBorderWidth */ .wW)("0px"),
        backgroundColor: $selected ? $theme.colors.primary200 : "unset",
        width: "min-content",
        whiteSpace: "nowrap",
        textUnderlinePosition: "under",
        color: "unset",
        ":hover": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset",
            color: $theme.colors.contentTertiary,
            cursor: "pointer"
        },
        ":active": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset"
        },
        ":focus-visible": {
            outline: `auto 1px ${$theme.colors.borderFocus}`
        },
        ...$style
    };
});


/***/ }),

/***/ 3935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PZ: () => (/* binding */ CloseButton),
/* harmony export */   fe: () => (/* binding */ ModalBody),
/* harmony export */   mz: () => (/* binding */ ModalFooter),
/* harmony export */   u_: () => (/* binding */ Modal),
/* harmony export */   xB: () => (/* binding */ ModalHeader)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72221);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76988);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7237);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _icons_CloseIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72832);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2780);
/* harmony import */ var _button_PlainButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4441);







const ModalHeader = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalHeader */ .xB, {
        $as: "header",
        ...props,
        $style: {
            ...$theme.typography.subHeading,
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .ds)($theme.sizing.scale600),
            ...props.$style
        }
    });
};
const ModalBody = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalBody */ .fe, {
        $as: "section",
        ...props,
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .ds)($theme.sizing.scale600),
            color: $theme.colors.contentPrimary,
            ...props.$style
        }
    });
};
const ModalFooter = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalFooter */ .mz, {
        $as: "footer",
        ...props,
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .ds)($theme.sizing.scale600),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .paddingVertical */ .i6)(0),
            display: "flex",
            gap: $theme.sizing.scale500,
            justifyContent: "end",
            alignItems: "center",
            ...props.$style
        }
    });
};
const Modal = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    const overrides = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* .mergeOverrides */ .aO)({
        Close: {
            component: CloseButton
        },
        Dialog: {
            style: {
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandBorderRadii */ .uJ)("8px"),
                boxShadow: $theme.lighting.depth4
            }
        }
    }, props.overrides);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        unstable_ModalBackdropScroll: true,
        ...props,
        overrides: overrides
    }, props.raw ? props.children : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalHeader, null, props.title), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalBody, null, props.children), (props.footer || props.footerLeft) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalFooter, null, props.footerLeft && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            marginRight: "auto"
        })
    }, props.footerLeft), props.footer)));
};
const CloseButton = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_button_PlainButton__WEBPACK_IMPORTED_MODULE_6__/* .PlainButton */ .D, {
        ...props,
        type: "button",
        $style: {
            position: "absolute",
            top: $theme.sizing.scale500,
            right: $theme.sizing.scale500,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_7__/* .CloseIcon */ .T, null));
};


/***/ }),

/***/ 77233:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ AccordionExpandIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74995);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);




const AccordionExpandIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_3__/* .Svg */ .n, {
        viewBox: "0 0 30 30",
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(props, "direction")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
        d: "M20.625 15.0001C20.625 15.1974 20.5494 15.3948 20.3991 15.5451L12.6908 23.2534C12.4704 23.4738 12.1389 23.5401 11.8506 23.4207C11.5623 23.3019 11.375 23.0198 11.375 22.7084V7.29179C11.375 6.98037 11.5623 6.69825 11.8506 6.57954C12.1389 6.46006 12.4704 6.52635 12.6908 6.74681L20.3991 14.4551C20.5494 14.6054 20.625 14.8028 20.625 15.0001Z",
        fill: props.color || $theme.colors.contentSecondary,
        transform: `rotate(${rotation} 15 15)`
    }));
};


/***/ }),

/***/ 72832:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ CloseIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const CloseIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.14478 3.17316C2.18007 3.34135 2.26456 3.49524 2.3875 3.61529L6.77382 8.00162L2.38794 12.3875C2.3055 12.4671 2.23964 12.5622 2.19418 12.6673C2.14843 12.7732 2.12426 12.8871 2.12309 13.0024C2.12192 13.1177 2.14376 13.2321 2.18735 13.3388C2.23093 13.4456 2.29537 13.5426 2.37691 13.6241C2.45844 13.7056 2.55542 13.7701 2.66217 13.8136C2.76893 13.8572 2.8833 13.8791 2.9986 13.8779C3.1139 13.8767 3.22781 13.8526 3.33365 13.8068C3.43883 13.7614 3.53395 13.6955 3.6135 13.613L7.99937 9.22717L12.3853 13.613C12.4648 13.6955 12.5599 13.7614 12.6651 13.8068C12.7709 13.8526 12.8848 13.8767 13.0001 13.8779C13.1155 13.8791 13.2298 13.8572 13.3366 13.8136C13.4433 13.7701 13.5403 13.7056 13.6218 13.6241C13.7034 13.5426 13.7678 13.4456 13.8114 13.3388C13.855 13.2321 13.8768 13.1177 13.8757 13.0024C13.8745 12.8871 13.8503 12.7732 13.8046 12.6673C13.7591 12.5622 13.6932 12.4671 13.6108 12.3875L9.22492 8.00162L13.6108 3.61576C13.736 3.49505 13.822 3.33945 13.8576 3.16917C13.8934 2.99815 13.8767 2.82032 13.8096 2.65899C13.7425 2.49766 13.6282 2.36037 13.4818 2.26512C13.3353 2.16987 13.1635 2.12111 12.9888 2.12524C12.7605 2.13063 12.5436 2.22588 12.3852 2.39025L7.99937 6.77607L3.61306 2.38975C3.5324 2.30713 3.43605 2.24144 3.32965 2.19657C3.2228 2.1515 3.10793 2.12834 2.99196 2.12844C2.81963 2.12866 2.65127 2.18024 2.5084 2.2766C2.36553 2.37296 2.25462 2.50972 2.18985 2.66942C2.12508 2.82912 2.10939 3.0045 2.14478 3.17316Z"
    }));


/***/ }),

/***/ 56931:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ ExternalLinkIconBox),
/* harmony export */   h: () => (/* binding */ ExternalLinkIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


// Arrow pointing through the top right corner of a square outline
const ExternalLinkIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M13.653 1.66042C13.6284 1.66123 13.6038 1.66341 13.5794 1.66693H9.33268C9.24434 1.66568 9.15663 1.68201 9.07465 1.71495C8.99267 1.74789 8.91806 1.7968 8.85515 1.85883C8.79223 1.92086 8.74228 1.99477 8.70818 2.07628C8.67408 2.15778 8.65652 2.24525 8.65652 2.3336C8.65652 2.42195 8.67408 2.50942 8.70818 2.59092C8.74228 2.67243 8.79223 2.74634 8.85515 2.80837C8.91806 2.8704 8.99267 2.91931 9.07465 2.95225C9.15663 2.9852 9.24434 3.00152 9.33268 3.00027H12.0566L7.528 7.52891C7.46401 7.59034 7.41293 7.66392 7.37774 7.74534C7.34255 7.82676 7.32396 7.91438 7.32305 8.00308C7.32215 8.09177 7.33896 8.17975 7.37248 8.26187C7.40601 8.34399 7.45558 8.4186 7.5183 8.48131C7.58102 8.54403 7.65562 8.59361 7.73774 8.62713C7.81986 8.66066 7.90785 8.67746 7.99654 8.67656C8.08523 8.67566 8.17286 8.65707 8.25427 8.62188C8.33569 8.58669 8.40927 8.5356 8.4707 8.47162L12.9993 3.94298V6.66693C12.9981 6.75528 13.0144 6.84298 13.0474 6.92496C13.0803 7.00694 13.1292 7.08156 13.1912 7.14447C13.2533 7.20738 13.3272 7.25734 13.4087 7.29144C13.4902 7.32554 13.5777 7.3431 13.666 7.3431C13.7544 7.3431 13.8418 7.32554 13.9233 7.29144C14.0048 7.25734 14.0788 7.20738 14.1408 7.14447C14.2028 7.08156 14.2517 7.00694 14.2847 6.92496C14.3176 6.84298 14.3339 6.75528 14.3327 6.66693V2.41563C14.3455 2.31985 14.3374 2.22241 14.3089 2.13007C14.2804 2.03774 14.2321 1.9527 14.1675 1.88087C14.1028 1.80903 14.0233 1.75211 13.9345 1.71405C13.8456 1.67598 13.7496 1.65769 13.653 1.66042ZM4.16602 2.66693C2.79358 2.66693 1.66602 3.7945 1.66602 5.16693V11.8336C1.66602 13.206 2.79358 14.3336 4.16602 14.3336H10.8327C12.2051 14.3336 13.3327 13.206 13.3327 11.8336V8.66693C13.3339 8.57859 13.3176 8.49088 13.2847 8.40891C13.2517 8.32693 13.2028 8.25231 13.1408 8.1894C13.0788 8.12649 13.0048 8.07653 12.9233 8.04243C12.8418 8.00833 12.7544 7.99077 12.666 7.99077C12.5777 7.99077 12.4902 8.00833 12.4087 8.04243C12.3272 8.07653 12.2533 8.12649 12.1912 8.1894C12.1292 8.25231 12.0803 8.32693 12.0474 8.40891C12.0144 8.49088 11.9981 8.57859 11.9993 8.66693V11.8336C11.9993 12.4825 11.4816 13.0003 10.8327 13.0003H4.16602C3.51712 13.0003 2.99935 12.4825 2.99935 11.8336V5.16693C2.99935 4.51804 3.51712 4.00027 4.16602 4.00027H7.33268C7.42102 4.00152 7.50873 3.9852 7.59071 3.95225C7.67269 3.91931 7.7473 3.8704 7.81022 3.80837C7.87313 3.74634 7.92309 3.67243 7.95719 3.59092C7.99128 3.50942 8.00884 3.42195 8.00884 3.3336C8.00884 3.24525 7.99128 3.15778 7.95719 3.07628C7.92309 2.99477 7.87313 2.92086 7.81022 2.85883C7.7473 2.7968 7.67269 2.74789 7.59071 2.71495C7.50873 2.68201 7.42102 2.66568 7.33268 2.66693H4.16602Z"
    }));
// Solid colored box with an internal arrow pointing to top right corner
const ExternalLinkIconBox = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M12.1667 2H3.83333C2.82233 2 2 2.82267 2 3.83333V12.1667C2 13.1773 2.82233 14 3.83333 14H12.1667C13.1777 14 14 13.1773 14 12.1667V3.83333C14 2.82267 13.1777 2 12.1667 2ZM12 8.16667C12 8.44267 11.7763 8.66667 11.5 8.66667C11.2237 8.66667 11 8.44267 11 8.16667V5.707L5.85367 10.8537C5.756 10.9513 5.628 11 5.5 11C5.372 11 5.244 10.9513 5.14633 10.8537C4.951 10.6583 4.951 10.342 5.14633 10.1467L10.293 5H7.83333C7.557 5 7.33333 4.776 7.33333 4.5C7.33333 4.224 7.557 4 7.83333 4H11.5C11.7763 4 12 4.224 12 4.5V8.16667Z"
    })));


/***/ }),

/***/ 78902:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  M: () => (/* binding */ GadgetLogoMark),
  u: () => (/* binding */ GadgetLogoType)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logomark.svg
/* harmony default export */ const logomark = (__webpack_require__.p + "1b5b906861f70ec70ea51c35c1e023be.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logotype.svg
/* harmony default export */ const logotype = (__webpack_require__.p + "13513703c5b41ce947547e20671b9409.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx



const GadgetLogoType = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logotype
    });
};
const GadgetLogoMark = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logomark
    });
};


/***/ }),

/***/ 4131:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: () => (/* binding */ WarningIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74995);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);




const WarningIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_3__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(props, "backgroundColor")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("rect", {
        x: "7",
        y: "5",
        width: "2",
        height: "8",
        fill: props.backgroundColor ?? (props.$disabled ? "transparent" : "black")
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
        d: "M7.99998 1.59998C7.55648 1.59998 7.17655 1.87023 7.01561 2.25518L1.22707 12.2385V12.2396C1.1226 12.4078 1.06705 12.6019 1.06665 12.8C1.06665 13.0829 1.17903 13.3542 1.37907 13.5542C1.57911 13.7543 1.85042 13.8666 2.13332 13.8666C2.15835 13.8665 2.18336 13.8654 2.20832 13.8635L2.2104 13.8666H7.99998H13.7896L13.7917 13.8625C13.8166 13.8647 13.8416 13.8661 13.8667 13.8666C14.1495 13.8666 14.4209 13.7543 14.6209 13.5542C14.8209 13.3542 14.9333 13.0829 14.9333 12.8C14.9331 12.6015 14.8776 12.4071 14.7729 12.2385L14.7646 12.2239C14.7642 12.2236 14.7639 12.2232 14.7635 12.2229L8.98436 2.25518C8.82342 1.87023 8.44349 1.59998 7.99998 1.59998ZM7.35311 6.05831H8.64686L8.53957 9.51039H7.4604L7.35311 6.05831ZM8.00207 10.5656C8.44047 10.5656 8.70311 10.8015 8.70311 11.2041C8.70311 11.5993 8.44047 11.8343 8.00207 11.8343C7.56047 11.8343 7.29582 11.5993 7.29582 11.2041C7.29582 10.8015 7.55993 10.5656 8.00207 10.5656Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.yellow500)
    }));
};


/***/ }),

/***/ 90546:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ Heading)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Heading = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("h1", ({ $theme })=>({
        ...$theme.typography.heading,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 14005:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: () => (/* binding */ CenteredSpin)
/* harmony export */ });
/* unused harmony export DelayedCenteredSpin */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60674);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



/** Renders a spinner that centers itself horizontally and vertically in the parent container */ const CenteredSpin = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            paddingLeft: $theme.sizing.scale600,
            paddingRight: $theme.sizing.scale600,
            paddingTop: $theme.sizing.scale600,
            paddingBottom: $theme.sizing.scale600,
            display: "flex",
            flexDirection: "column",
            gap: $theme.sizing.scale600,
            alignItems: "center",
            justifyContent: "center"
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_spinner__WEBPACK_IMPORTED_MODULE_2__/* .StyledSpinnerNext */ .aN, {
        $size: baseui_spinner__WEBPACK_IMPORTED_MODULE_3__/* .SIZE */ .N.large
    }), props?.children));
};
const DelayedCenteredSpin = (props)=>{
    const [showSpinner, setShowSpinner] = useState(false);
    const delay = props.delay ?? 0;
    useEffect(()=>{
        const timer = setTimeout(()=>{
            setShowSpinner(true);
        }, delay ?? 0);
        return ()=>clearTimeout(timer);
    }, [
        delay
    ]);
    return showSpinner ? /*#__PURE__*/ React.createElement(CenteredSpin, null) : null;
};


/***/ }),

/***/ 52661:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ ErrorDisplay),
/* harmony export */   x: () => (/* binding */ DebugDisplay)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93610);
/* harmony import */ var _gadgetinc_widgets_src_EditTheme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86512);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94922);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10334);
/* harmony import */ var baseui_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61022);
/* harmony import */ var fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4329);
/* harmony import */ var fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26969);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79409);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isError__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76705);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30242);
/* harmony import */ var state_trees_src_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94910);











const ReactJson = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName () {
        return "react-json-view";
    },
    isReady (props1) {
        const key = this.resolve(props1);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: ()=>__webpack_require__.e(/* import() | react-json-view */ 2229).then(__webpack_require__.t.bind(__webpack_require__, 41575, 23)),
    requireAsync (props1) {
        const key = this.resolve(props1);
        this.resolved[key] = false;
        return this.importAsync(props1).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props1) {
        const id = this.resolve(props1);
        if (true) {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (true) {
            return /*require.resolve*/(41575);
        }
        return eval('require.resolve')("react-json-view");
    }
});
const Pre = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .styled */ .zo)("pre", ({ $theme: $theme1 })=>({
        fontFamily: _gadgetinc_widgets_src_EditTheme__WEBPACK_IMPORTED_MODULE_8__/* .monoFontFamily */ .CK,
        overflow: "auto",
        paddingLeft: $theme1.sizing.scale300,
        paddingRight: $theme1.sizing.scale300,
        paddingTop: $theme1.sizing.scale300,
        paddingBottom: $theme1.sizing.scale300,
        marginBottom: $theme1.sizing.scale400,
        borderRadius: $theme1.borders.radius200
    }));
const ErrorDisplay = (props1)=>{
    const [_css1, $theme1] = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .useStyletron */ .hQ)();
    let output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(Pre, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(baseui_typography__WEBPACK_IMPORTED_MODULE_9__/* .Label3 */ .T3, {
        $style: {
            color: $theme1.colors.negative500
        }
    }, (0,state_trees_src_utils__WEBPACK_IMPORTED_MODULE_6__/* .errorMessage */ .N3)(props1.error)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(baseui_typography__WEBPACK_IMPORTED_MODULE_9__/* .Label4 */ .cV, {
        $style: {
            color: $theme1.colors.negative500
        }
    }, "stack" in props1.error ? props1.error.stack : "<stack unknown>"), props1.extra && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(DebugDisplay, {
        data: props1.extra
    }));
    if (props1.error.graphQLErrors) {
        const errorWithRemedy1 = lodash_find__WEBPACK_IMPORTED_MODULE_2___default()(props1.error.graphQLErrors, "extensions.remedy");
        if (errorWithRemedy1) {
            // This can't be null given the above `find` can only give us a truthy value if it is set
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const remedy1 = errorWithRemedy1.extensions.remedy;
            output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(react__WEBPACK_IMPORTED_MODULE_5__.Fragment, null, output1, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                href: remedy1.href
            }, remedy1.text));
        }
    }
    return output1;
};
const DebugDisplay = (props1)=>{
    const [css1] = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .useStyletron */ .hQ)();
    let output1;
    if (lodash_isError__WEBPACK_IMPORTED_MODULE_3___default()(props1.data)) {
        output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ErrorDisplay, {
            error: props1.data
        });
    } else {
        let jsonString1;
        try {
            if (lodash_isString__WEBPACK_IMPORTED_MODULE_4___default()(props1.data)) {
                output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("code", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("pre", null, props1.data));
            } else {
                let json1;
                if (props1.data) {
                    jsonString1 = fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1___default()(Object.prototype.hasOwnProperty.call(props1.data, "toJSON") ? props1.data.toJSON() : props1.data);
                    json1 = JSON.parse(jsonString1 ?? "{}");
                } else {
                    json1 = String(props1.data);
                }
                output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ReactJson, {
                    src: json1,
                    collapsed: 2,
                    collapseStringsAfterLength: 100
                });
            }
        } catch (e1) {
            output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ErrorDisplay, {
                error: e1,
                extra: {
                    json: jsonString1
                }
            });
        }
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
        className: css1({
            maxWidth: "1000px",
            ...props1.$style
        })
    }, output1);
};


/***/ }),

/***/ 3228:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  O: () => (/* binding */ ErrorNavBar),
  T: () => (/* binding */ NotFound)
});

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(7363);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx + 2 modules
var GadgetLogo = __webpack_require__(78902);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/NotFoundSVG.tsx

const NotFoundSVG = ()=>{
    return /*#__PURE__*/ react.createElement("svg", {
        width: "718",
        height: "492",
        viewBox: "0 0 718 492",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M157.549 117.628C392.871 -5.34513 489.039 -11.1229 607.425 79.6259C785.103 215.824 660.451 344.686 573.213 365.051C415.511 401.865 103.024 524.611 27.1169 387.165C-22.3674 297.563 -3.95233 202.025 157.549 117.628Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M166.472 491.587C193.344 431.079 144.831 377.716 209.991 331.025C275.151 284.333 359.812 361.994 392.154 233.829C416.031 139.254 493.938 170.462 493.7 54.9233H717.242C717.48 170.462 639.573 139.254 615.697 233.829C583.355 361.994 498.694 284.333 433.534 331.025C368.373 377.716 416.887 431.079 390.014 491.587H166.472Z",
        fill: "white"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M180.598 471.767H200.526V491.635H180.598V471.767Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M220.503 471.767H240.431V491.635H220.503V471.767Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M260.36 471.767H280.288V491.635H260.36V471.767Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M300.264 471.767H320.193V491.635H300.264V471.767Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M340.121 471.767H360.05V491.635H340.121V471.767Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M180.598 431.936H200.526V451.804H180.598V431.936Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M220.503 431.936H240.431V451.804H220.503V431.936Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M260.36 431.936H280.288V451.804H260.36V431.936Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M300.264 431.936H320.193V451.804H300.264V431.936Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M340.121 431.936H360.05V451.804H340.121V431.936Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M200.526 451.852H220.455V471.719H200.526V451.852Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M240.431 451.852H260.36V471.719H240.431V451.852Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M280.288 451.852H300.217V471.719H280.288V451.852Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M320.193 451.852H340.121V471.719H320.193V451.852Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M360.098 451.852H380.026V471.719H360.098V451.852Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M200.526 392.153H180.598V412.021H200.526V431.889H220.455V412.021H200.526V392.153Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M220.503 392.153H240.431V412.021H220.503V392.153Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M260.36 392.153H280.288V412.021H260.36V392.153Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M300.264 392.153H320.193V412.021H300.264V392.153Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M340.121 392.153H360.05V412.021H340.121V392.153Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M240.431 412.02H260.36V431.888H240.431V412.02Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M280.288 412.02H300.217V431.888H280.288V412.02Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M320.193 412.02H340.121V431.888H320.193V412.02Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M360.098 412.02H380.026V431.888H360.098V412.02Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M220.503 352.322H240.431V372.19H220.503V352.322Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M260.36 352.322H280.288V372.19H260.36V352.322Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M300.264 352.322H320.193V372.19H300.264V352.322Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M340.121 352.322H360.05V372.19H340.121V352.322Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M380.026 352.322H399.955V372.19H380.026V352.322Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M240.431 372.19H260.36V392.057H240.431V372.19Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M280.288 372.19H300.217V392.057H280.288V372.19Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M320.193 372.19H340.121V392.057H320.193V372.19Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M360.098 372.19H380.026V392.057H360.098V372.19Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M340.121 312.491H360.05V332.359H340.121V312.491Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M380.026 312.491H399.955V332.359H380.026V312.491Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M240.431 332.406H260.36V352.274H240.431V332.406Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M280.288 332.406H300.217V352.274H280.288V332.406Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M320.193 332.406H340.121V352.274H320.193V332.406Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M360.098 332.406H380.026V352.274H360.098V332.406Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M380.026 272.707H399.955V292.575H380.026V272.707Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M439.859 272.707H419.931V292.575H439.859V312.443H459.788V292.575H439.859V272.707Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M459.788 272.707H479.717V292.575H459.788V272.707Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M499.693 272.707V292.575H479.764V312.443H499.693V292.575H519.621V272.707H499.693Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M539.597 272.707H559.526V292.575H539.597V272.707Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M399.955 292.575H419.883V312.443H399.955V292.575Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M519.621 292.575H539.55V312.443H519.621V292.575Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M419.931 232.877H439.859V252.744H419.931V232.877Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M459.788 232.877H479.717V252.744H459.788V232.877Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M499.693 232.877H519.621V252.744H499.693V232.877Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M539.597 232.877H559.526V252.744H539.597V232.877Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M579.454 232.877H599.383V252.744H579.454V232.877Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M399.955 252.791H419.883V272.659H399.955V252.791Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M439.859 252.791H459.788V272.659H439.859V252.791Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M479.764 252.791H499.693V272.659H479.764V252.791Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M519.621 252.791H539.55V272.659H519.621V252.791Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M559.526 252.791H579.454V272.659H559.526V252.791Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M439.859 193.093H419.931V212.961H439.859V232.828H459.788V212.961H439.859V193.093Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M459.788 193.093H479.717V212.961H459.788V193.093Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M499.693 193.093V212.961H479.764V232.828H499.693V212.961H519.621V193.093H499.693Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M539.597 193.093H559.526V212.961H539.597V193.093Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M579.454 212.961H559.526V232.828H579.454V212.961H599.383V193.093H579.454V212.961Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M399.955 212.961H419.883V232.829H399.955V212.961Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M519.621 212.961H539.55V232.829H519.621V212.961Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M459.788 153.262H479.717V173.13H459.788V153.262Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M499.693 153.262H519.621V173.13H499.693V153.262Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M539.597 153.262H559.526V173.13H539.597V153.262Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M579.454 153.262H599.383V173.13H579.454V153.262Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M619.359 153.262H639.288V173.13H619.359V153.262Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M439.859 173.177H459.788V193.045H439.859V173.177Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M479.764 173.177H499.693V193.045H479.764V173.177Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M519.621 173.177H539.55V193.045H519.621V173.177Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M559.526 173.177H579.454V193.045H559.526V173.177Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M599.431 173.177H619.359V193.045H599.431V173.177Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M499.693 113.479V133.347H479.764V153.214H499.693V133.347H519.621V113.479H499.693Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M539.597 113.479H559.526V133.347H539.597V113.479Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M579.454 133.347H559.526V153.214H579.454V133.347H599.383V113.479H579.454V133.347Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M639.288 113.479H619.359V133.347H639.288V153.214H659.216V133.347H639.288V113.479Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M659.264 113.479H679.192V133.347H659.264V113.479Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M519.621 133.347H539.55V153.215H519.621V133.347Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M599.431 133.347H619.359V153.215H599.431V133.347Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M499.693 73.6476H519.621V93.5154H499.693V73.6476Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M539.597 73.6476H559.526V93.5154H539.597V73.6476Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M579.454 73.6476H599.383V93.5154H579.454V73.6476Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M619.359 73.6476H639.288V93.5154H619.359V73.6476Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M659.264 73.6476H679.192V93.5154H659.264V73.6476Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M519.621 93.5629H539.55V113.431H519.621V93.5629Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M559.526 93.5629H579.454V113.431H559.526V93.5629Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M599.431 93.5629H619.359V113.431H599.431V93.5629Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M639.288 93.5629H659.216V113.431H639.288V93.5629Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M679.193 93.5629H699.121V113.431H679.193V93.5629Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M699.121 73.6476V93.5154H713.58C714.912 87.5122 715.911 80.9372 716.529 73.6476H699.121Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M707.159 113.479H699.121V127.82C702.07 123.532 704.781 118.815 707.159 113.479Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M694.983 133.347H679.193V149.165C684.805 144.353 690.132 139.255 694.983 133.347Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M659.264 153.262V165.364C664.258 161.171 669.347 157.264 674.246 153.262H659.264Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M650.417 173.177H639.288V185.041C642.855 180.705 646.612 176.798 650.417 173.177Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M619.359 193.093V212.961H622.593C625.78 205.385 629.395 198.858 633.295 193.093H619.359Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M599.431 232.829H615.935C616.981 228.826 618.123 225.015 619.359 221.442V212.961H599.431V232.829Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M599.431 252.791V272.659H601.381C604.472 266.894 607.374 260.319 610.037 252.791H599.431Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M579.454 292.575H559.526V309.06C566.518 306.916 573.176 303.772 579.454 299.103V292.575H587.017C591.44 288.144 595.578 282.713 599.383 276.186V272.707H579.454V292.575Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M499.693 313.587C506.399 313.491 513.058 313.587 519.621 313.539V312.491H499.693V313.587Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M459.788 318.399C466.352 316.493 473.01 315.35 479.717 314.635V312.491H459.788V318.399Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M439.859 312.491H419.931V332.359H431.726C432.345 331.93 432.915 331.453 433.534 331.025C435.626 329.548 437.719 328.166 439.859 326.927V312.491Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M419.883 332.406H399.955V352.274H411.417C413.843 348.987 416.649 345.699 419.883 342.459V332.406Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M399.955 372.19V376.859C400.335 375.286 400.763 373.714 401.286 372.19H399.955Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M397.672 392.153H380.026V412.021H397.624C397.339 405.303 397.196 398.68 397.672 392.153Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M380.026 451.804H398.861C399.146 445.086 399.003 438.464 398.718 431.936H380.026V451.804Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M380.026 491.587H390.014C393.011 484.917 395.056 478.294 396.435 471.767H380.026V491.587Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M679.193 54.9233H699.121V73.6H679.193V54.9233Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M639.288 54.9233H659.216V73.6H639.288V54.9233Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M599.431 54.9233H619.359V73.6H599.431V54.9233Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M559.526 54.9233H579.454V73.6H559.526V54.9233Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M519.621 54.9233H539.55V73.6H519.621V54.9233Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M499.693 73.6V54.9233H493.7C493.7 61.6412 493.462 67.835 492.986 73.6H499.693Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M483.617 113.431H499.693V93.5629H490.038C488.373 101.043 486.185 107.618 483.617 113.431Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M471.441 133.347H479.717V121.245C477.196 125.676 474.39 129.678 471.441 133.347Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M459.788 153.215V145.496C456.839 148.164 453.843 150.69 450.799 153.215H459.788Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M439.859 173.13V161.981C435.531 165.507 431.156 169.128 426.922 173.13H439.859Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M419.883 193.045V180.277C416.364 184.136 412.987 188.329 409.753 193.045H419.883Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M399.051 212.961H399.955V210.864C399.669 211.531 399.336 212.246 399.051 212.961Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M386.495 252.744H399.955V232.877H392.392C392.297 233.21 392.25 233.496 392.155 233.829C390.395 240.69 388.54 246.979 386.495 252.744Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M377.838 272.66H380.026V268.372C379.313 269.848 378.599 271.278 377.838 272.66Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M360.098 295.767V312.443H380.026V292.575H363.474C362.333 293.671 361.239 294.767 360.098 295.767Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M340.121 307.679C333.748 310.061 327.089 311.49 320.193 312.348V312.491H340.121V307.679Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M320.193 312.491H318.718C312.726 313.158 306.543 313.396 300.264 313.491V332.359H320.193V312.491Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M280.288 313.539C273.677 313.586 267.018 313.729 260.36 314.253V332.358H280.288V313.539Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M240.431 317.303C233.677 318.923 227.019 321.257 220.503 324.64V332.406H240.431V317.303Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M220.455 332.406H208.089C205.378 334.455 202.857 336.504 200.526 338.552V352.274H220.455V332.406Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M187.827 352.322C184.878 356.419 182.5 360.517 180.598 364.709V372.19H200.526V392.057H220.455V372.19H200.526V352.322H187.827Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M180.598 392.057V372.19H177.744C175.699 378.717 174.605 385.339 174.129 392.057H180.598Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M180.598 412.02H174.082C174.367 418.548 174.843 425.17 175.128 431.888H180.598V412.02Z",
        fill: "#ECECFF"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M180.598 471.719V451.852H175.318C175.033 458.379 174.32 465.002 172.893 471.719H180.598Z",
        fill: "#ECECFF"
    })), /*#__PURE__*/ react.createElement("path", {
        d: "M309.755 345.041H24.2382V131.026L52.1143 102.092L309.755 131.026V345.041Z",
        fill: "#FFDD5C"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M307.755 343.039H26.2382V131.831L52.8706 104.188L307.755 132.812V343.039Z",
        fill: "white",
        stroke: "#333333",
        strokeWidth: "4"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M335.443 315.544L308.906 343.04H26.2382V193.259L52.8697 165.666L308.117 194.28L335.443 315.544Z",
        fill: "#333333",
        stroke: "#333333",
        strokeWidth: "4"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M54.1848 311.929L26.32 340.804L28.7218 343.131L56.5866 314.256L54.1848 311.929Z",
        fill: "#333333"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M54.1153 314.157V104.092H335.632V314.157H54.1153Z",
        fill: "#FFDD5C",
        stroke: "#333333",
        strokeWidth: "4"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M54.1153 314.207V165.568H335.632V314.207H54.1153Z",
        fill: "white",
        stroke: "#333333",
        strokeWidth: "4"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M82.1927 141.154C87.168 141.154 91.2012 137.113 91.2012 132.128C91.2012 127.143 87.168 123.102 82.1927 123.102C77.2175 123.102 73.1843 127.143 73.1843 132.128C73.1843 137.113 77.2175 141.154 82.1927 141.154Z",
        stroke: "#333333",
        strokeWidth: "4"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M112.121 141.154C117.096 141.154 121.129 137.113 121.129 132.128C121.129 127.143 117.096 123.102 112.121 123.102C107.146 123.102 103.112 127.143 103.112 132.128C103.112 137.113 107.146 141.154 112.121 141.154Z",
        stroke: "#333333",
        strokeWidth: "4"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M142.048 141.154C147.023 141.154 151.057 137.113 151.057 132.128C151.057 127.143 147.023 123.102 142.048 123.102C137.073 123.102 133.04 127.143 133.04 132.128C133.04 137.113 137.073 141.154 142.048 141.154Z",
        stroke: "#333333",
        strokeWidth: "4"
    }), /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_207_7",
        style: {
            maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "131",
        y: "180",
        width: "207",
        height: "193"
    }, /*#__PURE__*/ react.createElement("rect", {
        x: "131.407",
        y: "180",
        width: "206",
        height: "193",
        fill: "#D9D9D9"
    })), /*#__PURE__*/ react.createElement("g", {
        mask: "url(#mask0_207_7)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M200.386 294.173V296.173H202.386H221.063H223.063V294.173V277.659H245.682H247.682V275.659V261.384V259.384H245.682H223.063V205.982V203.982H221.063H206.064H205.417L204.892 204.361L122.828 263.721L122 264.32V265.342V275.517V277.517H124H200.386V294.173ZM463.978 294.173V296.173H465.978H484.655H486.655V294.173V277.659H509.275H511.275V275.659V261.384V259.384H509.275H486.655V205.982V203.982H484.655H469.657H469.009L468.485 204.361L386.42 263.721L385.592 264.32V265.342V275.517V277.517H387.592H463.978V294.173ZM286.647 292.461L286.656 292.465L286.665 292.469C295.273 296.28 305.323 298.152 316.763 298.152C328.202 298.152 338.253 296.28 346.861 292.469L346.87 292.465L346.878 292.461C355.469 288.56 362.189 283.108 366.949 276.076C371.821 268.924 374.227 260.56 374.227 251.067C374.227 241.848 371.816 233.674 366.949 226.623C362.194 219.505 355.481 213.959 346.895 209.963C338.277 205.953 328.215 203.982 316.763 203.982C305.311 203.982 295.248 205.953 286.63 209.963L287.474 211.777L286.63 209.963C278.042 213.96 271.285 219.506 266.437 226.621L266.434 226.626C261.66 233.679 259.298 241.851 259.298 251.067C259.298 260.552 261.653 268.911 266.426 276.062L266.435 276.076L266.444 276.089C271.297 283.112 278.058 288.561 286.647 292.461ZM463.978 229.913V259.243H422.47L463.978 229.913Z",
        fill: "#333333",
        stroke: "#333333",
        strokeWidth: "4"
    })), /*#__PURE__*/ react.createElement("path", {
        d: "M225.434 282.853V284.853H227.434H245.283H247.283V282.853V267.158H268.812H270.812V265.158V251.516V249.516H268.812H247.283V198.569V196.569H245.283H230.95H230.302L229.778 196.948L151.349 253.678L150.521 254.277V255.298V265.023V267.023H152.521H225.434V282.853ZM477.348 282.853V284.853H479.348H497.198H499.198V282.853V267.158H520.727H522.727V265.158V251.516V249.516H520.727H499.198V198.569V196.569H497.198H482.864H482.217L481.692 196.948L403.263 253.678L402.435 254.277V255.298V265.023V267.023H404.435H477.348V282.853ZM318.985 265.607C317.779 265.096 316.638 264.533 315.561 263.918L368.765 232.425C369.789 235.23 370.307 238.301 370.307 241.656C370.307 247.372 368.987 252.157 366.436 256.103L366.428 256.116L366.42 256.128C363.957 260.065 360.28 263.151 355.275 265.354C350.275 267.555 344.119 268.696 336.744 268.696C329.92 268.696 324.014 267.649 318.985 265.607ZM355.249 218.217C356.387 218.737 357.457 219.303 358.46 219.914L304.958 252.159C303.784 249.123 303.18 245.633 303.18 241.656C303.18 236.355 304.563 231.761 307.288 227.801C310.13 223.711 314.029 220.512 319.05 218.217L319.063 218.211L319.075 218.205C324.079 215.833 329.952 214.616 336.744 214.616C344.102 214.616 350.238 215.842 355.224 218.205L355.237 218.211L355.249 218.217ZM307.926 281.297L307.935 281.301L307.943 281.305C316.184 284.953 325.802 286.744 336.744 286.744C347.686 286.744 357.304 284.953 365.545 281.305L365.553 281.301L365.562 281.297C373.785 277.563 380.22 272.342 384.779 265.607C389.447 258.755 391.751 250.744 391.751 241.656C391.751 232.829 389.442 225 384.78 218.246C380.225 211.428 373.797 206.118 365.579 202.293L364.735 204.106L365.579 202.293C357.329 198.454 347.699 196.569 336.744 196.569C325.789 196.569 316.159 198.454 307.909 202.293C299.688 206.119 293.217 211.429 288.575 218.243L288.571 218.248C283.998 225.005 281.737 232.832 281.737 241.656C281.737 250.737 283.991 258.742 288.564 265.593L288.573 265.607L288.582 265.62C293.229 272.346 299.704 277.564 307.926 281.297ZM225.434 221.611V249.381H186.132L225.434 221.611ZM477.348 221.611V249.381H438.046L477.348 221.611Z",
        fill: "#8E8EFD",
        stroke: "#333333",
        strokeWidth: "4"
    }));
};
/* harmony default export */ const icons_NotFoundSVG = (NotFoundSVG);

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
;// CONCATENATED MODULE: ./src/components/MarketingButton.tsx


const MarketingButton = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement("button", {
        onClick: props.onClick,
        className: css({
            cursor: "pointer",
            display: "inline-block",
            WebkitBoxPack: "start",
            justifyContent: "flex-start",
            flexWrap: "nowrap",
            alignItems: "center",
            border: "2px solid #2525cf",
            borderRadius: "6px",
            transition: "150ms",
            fontFamily: "Inconsolata,monospace",
            textAlign: "left",
            backgroundColor: "#e2e2e2",
            color: "#0b171e",
            borderColor: "#919191",
            boxShadow: "inset 0 3px 0 0 #f1f1f1,inset 0 -4px 0 0 #ababab",
            padding: "13px 20px 15px",
            fontSize: "19px",
            ":hover": {
                outline: "0",
                paddingTop: "14px",
                paddingBottom: "14px",
                borderColor: "#7c7c7c",
                boxShadow: "inset 0 2px 0 0 #ababab,inset 0 -2px 0 0 #f1f1f1"
            },
            ":active": {
                outline: "0",
                paddingTop: "15px",
                paddingBottom: "13px",
                borderColor: "#636363",
                boxShadow: "inset 0 4px 0 0 #f1f1f1,inset 0 0 0 0 #fff"
            },
            ...props.$style
        })
    }, props.children);
};
/* harmony default export */ const components_MarketingButton = (MarketingButton);

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(2780);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/AccordionExpandIcon.tsx
var AccordionExpandIcon = __webpack_require__(77233);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(74995);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/LogoutIcon.tsx


const LogoutIcon = (props)=>/*#__PURE__*/ react.createElement(styled_components/* Svg */.n, {
        viewBox: "0 0 14 14",
        ...props
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M7.00015 0.600006C5.63752 0.600006 4.37791 1.03658 3.34494 1.76355C3.28762 1.80383 3.2388 1.85501 3.20127 1.91417C3.16373 1.97332 3.13821 2.03929 3.12617 2.1083C3.11413 2.17732 3.1158 2.24803 3.13108 2.3164C3.14637 2.38477 3.17497 2.44946 3.21525 2.50678C3.25554 2.56409 3.30672 2.61291 3.36587 2.65045C3.42503 2.68799 3.49099 2.71351 3.56001 2.72555C3.62902 2.73759 3.69974 2.73592 3.76811 2.72064C3.83648 2.70535 3.90117 2.67675 3.95848 2.63646C4.82311 2.02797 5.86464 1.66667 7.00015 1.66667C9.9519 1.66667 12.3335 4.04825 12.3335 7.00001C12.3335 9.95176 9.9519 12.3333 7.00015 12.3333C5.86464 12.3333 4.82311 11.972 3.95848 11.3635C3.84273 11.2822 3.69939 11.2501 3.56001 11.2745C3.42063 11.2988 3.29661 11.3775 3.21525 11.4932C3.13389 11.609 3.10185 11.7523 3.12617 11.8917C3.15049 12.0311 3.22919 12.1551 3.34494 12.2365C4.37791 12.9634 5.63752 13.4 7.00015 13.4C10.5284 13.4 13.4002 10.5283 13.4002 7.00001C13.4002 3.47176 10.5284 0.600006 7.00015 0.600006ZM2.72307 4.32813C2.58451 4.33226 2.453 4.39017 2.3564 4.48959L0.269941 6.57605C0.204601 6.62589 0.151662 6.69016 0.115255 6.76383C0.0788482 6.83751 0.0599582 6.9186 0.060059 7.00078C0.0601598 7.08297 0.0792489 7.16401 0.115836 7.2376C0.152424 7.31119 0.205521 7.37532 0.270983 7.42501L2.3564 9.51042C2.40554 9.56161 2.46441 9.60247 2.52954 9.63063C2.59468 9.65878 2.66478 9.67365 2.73573 9.67437C2.80669 9.67509 2.87707 9.66165 2.94277 9.63483C3.00846 9.60801 3.06814 9.56835 3.11832 9.51817C3.16849 9.468 3.20815 9.40832 3.23497 9.34262C3.26179 9.27693 3.27524 9.20654 3.27452 9.13559C3.27379 9.06463 3.25892 8.99453 3.23077 8.9294C3.20262 8.86426 3.16175 8.8054 3.11057 8.75626L1.88765 7.53334H7.53348C7.60416 7.53434 7.67432 7.52128 7.73991 7.49493C7.80549 7.46857 7.86518 7.42945 7.91551 7.37982C7.96584 7.3302 8.00581 7.27107 8.03309 7.20586C8.06037 7.14066 8.07441 7.07069 8.07441 7.00001C8.07441 6.92933 8.06037 6.85935 8.03309 6.79415C8.00581 6.72894 7.96584 6.66981 7.91551 6.62019C7.86518 6.57056 7.80549 6.53144 7.73991 6.50508C7.67432 6.47873 7.60416 6.46567 7.53348 6.46667H1.88765L3.11057 5.24376C3.18763 5.16884 3.24027 5.07239 3.26158 4.96705C3.2829 4.86171 3.27189 4.75238 3.23 4.6534C3.18811 4.55442 3.1173 4.47041 3.02684 4.41237C2.93638 4.35432 2.8305 4.32496 2.72307 4.32813Z",
        fill: "black"
    }));

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/stateful-menu.js + 5 modules
var stateful_menu = __webpack_require__(54274);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/stateful-popover.js + 1 modules
var stateful_popover = __webpack_require__(27801);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/constants.js
var constants = __webpack_require__(64165);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(61022);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/compact.js
var compact = __webpack_require__(6494);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 16 modules
var es = __webpack_require__(22764);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-gravatar@2.6.3_react@0.0.0-experimental-4ead6b530/node_modules/react-gravatar/dist/index.js
var dist = __webpack_require__(52069);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./src/components/auth/UserDropdown.tsx











const UserDropdown = (0,es/* observer */.Pi)((props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const [menuOpen, setMenuOpen] = (0,react.useState)(false);
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $gap: $theme.sizing.scale200,
        className: css({
            ...props.$style
        })
    }, /*#__PURE__*/ react.createElement(stateful_popover/* default */.Z, {
        onOpen: ()=>setMenuOpen(true),
        onClose: ()=>setMenuOpen(false),
        placement: constants/* PLACEMENT */.r4.bottomRight,
        popoverMargin: 0,
        content: ({ close })=>/*#__PURE__*/ react.createElement(stateful_menu/* default */.Z, {
                overrides: {
                    Option: {
                        style: {
                            paddingTop: `calc(${$theme.sizing.scale200} - 1px)`,
                            paddingBottom: `calc(${$theme.sizing.scale200} - 1px)`,
                            color: $theme.colors.primaryA
                        }
                    }
                },
                items: compact_default()([
                    {
                        label: /*#__PURE__*/ react.createElement(Row/* Row */.X, {
                            $gap: $theme.sizing.scale400
                        }, /*#__PURE__*/ react.createElement(LogoutIcon, null), "Logout"),
                        onSelect: ()=>window.location.href = `${rootURL}/auth/logout`
                    }
                ]),
                onItemSelect: ({ item })=>{
                    item.onSelect();
                }
            })
    }, /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $gap: $theme.sizing.scale500,
        className: css({
            paddingTop: $theme.sizing.scale200,
            paddingBottom: $theme.sizing.scale200,
            paddingLeft: $theme.sizing.scale300,
            paddingRight: $theme.sizing.scale300,
            ...(0,utils/* expandBorderRadii */.uJ)($theme.borders.radius200),
            backgroundColor: menuOpen ? $theme.colors.backgroundQuaternary : undefined,
            cursor: "pointer",
            userSelect: "none",
            overflow: "hidden",
            ":hover": {
                backgroundColor: $theme.colors.backgroundQuaternary
            }
        })
    }, /*#__PURE__*/ react.createElement((dist_default()), {
        email: props.userEmail,
        size: 16,
        rating: "pg",
        default:  false ? 0 : "monsterid",
        className: css({
            ...(0,utils/* expandBorderRadii */.uJ)("50%")
        })
    }), /*#__PURE__*/ react.createElement(typography/* LabelSmall */.S$, {
        $style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }, props.userEmail), /*#__PURE__*/ react.createElement(AccordionExpandIcon/* AccordionExpandIcon */.K, {
        direction: menuOpen ? "up" : "down"
    }))));
});

;// CONCATENATED MODULE: ./src/components/chrome/NotFound.tsx







const ErrorNavBar = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    const logoProps = {
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/login`;
        },
        className: css({
            height: "46px",
            cursor: "pointer"
        })
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            position: "absolute",
            top: "0",
            left: "0",
            height: 53,
            paddingBottom: "30px",
            paddingTop: "32px",
            paddingLeft: "40px",
            paddingRight: "40px"
        })
    }, props.logoOnly ? /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoMark */.M, logoProps) : /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoType */.u, logoProps), props.showButtons ? /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            alignContent: "center",
            alignItems: "center"
        })
    }, /*#__PURE__*/ react.createElement("a", {
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/login`;
        },
        className: css({
            cursor: "pointer",
            fontFamily: "Inconsolata,monospace",
            fontWeight: 500,
            fontSize: $theme.sizing.scale650
        })
    }, "Login"), /*#__PURE__*/ react.createElement(components_MarketingButton, {
        $style: {
            height: "47px",
            marginLeft: "32px",
            backgroundColor: "#4242fc",
            borderColor: "#11118f",
            color: "#fff",
            padding: "11px 16px 13px 16px",
            fontSize: "18px",
            boxSizing: "border-box",
            boxShadow: "inset 0 3px 0 0 #7575ff,inset 0 -4px 0 0 #2b2bd9",
            ":hover": {
                paddingTop: "11px",
                paddingBottom: "11px",
                borderColor: "#11118f",
                boxShadow: "inset 0 2px 0 0 #2b2bd9, inset 0 -2px 0 0 #7575ff"
            },
            ":active": {
                paddingTop: "11px",
                paddingBottom: "11px",
                borderColor: "#030347",
                boxShadow: "inset 0 4px 0 0 #7575ff"
            }
        },
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/signup`;
        }
    }, "Sign Up")) : /*#__PURE__*/ react.createElement("div", null, props.user && /*#__PURE__*/ react.createElement(UserDropdown, {
        userEmail: props.user
    })));
};
const NotFound = ()=>{
    const [css] = (0,styled/* useStyletron */.hQ)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            width: "100%",
            height: "100%",
            overflow: "hidden"
        })
    }, /*#__PURE__*/ react.createElement(ErrorNavBar, null), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $style: {
            height: "100%"
        },
        $align: "center"
    }, /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            alignContent: "center",
            alignItems: "center"
        })
    }, /*#__PURE__*/ react.createElement(icons_NotFoundSVG, null), /*#__PURE__*/ react.createElement("div", {
        className: css({
            position: "relative",
            right: "250px",
            top: "155px"
        })
    }, /*#__PURE__*/ react.createElement("p", {
        className: css({
            fontSize: "32px",
            fontFamily: "Inconsolata, monospace",
            width: "374px",
            fontWeight: 500,
            marginBottom: "32px",
            marginRight: "-374px"
        })
    }, "Hmm, we can’t find the page you’re looking for"), /*#__PURE__*/ react.createElement(components_MarketingButton, {
        onClick: ()=>{
            window.location.href = `${rootURL}`;
        }
    }, "Gadget home")))));
};


/***/ })

}]);